module.exports = __webpack_public_path__ + "img/licensePlate.eabda2dc.svg";